import React from 'react';
import Fidelity from '../../../../../common/components/Fidelity';

export default {
  align: 'center',
  width: '60px',
  dataIndex: 'client.fidelityIndex',
  title: 'F.I.',
  sorter: (a, b) => a.fidelity - b.fidelity,
  render: text => <Fidelity percentage={(text || -1) * 100} />
};
